<template>
  <div id="nav">
    <div class="gic_header header_tablet step_bar_tablet">
    <div class="step_bar w-row">
       <slot></slot>
    </div>
  </div>
   <header class="gic_header header_tablet">
    <div class="header_columns w-row">
      <div class="header_column w-col w-col-2">
        <a href="#" class="back_button w-inline-block"><img src="@/assets/images/arrow-angle-pointing-to-right.svg" loading="lazy" alt=""></a>
      </div>
      <div class="header_column w-col w-col-5"><img class="bg-white" src="@/assets/images/GENIKES_127x40_72dpi.png" loading="lazy" width="108" alt=""></div>
      <div class="header_column call_column_tablet w-col w-col-5">
        <div class="call_link"><img src="@/assets/images/call.svg" loading="lazy" alt="" class="image-8">
          <h1 class="heading-5">8000.87.87</h1>
        </div>
      </div>
    </div>
  </header>
  <header class="gic_header header_desktop">
    <div class="header_columns w-row">
      <div class="header_column w-col w-col-1">
        <a href="https://www.gic.com.cy" target="_blank" class="back_button w-inline-block"><img src="@/assets/images/arrow-angle-pointing-to-right.svg" loading="lazy" alt=""></a>
      </div>
      <div class="header_column w-col w-col-2"><img class="bg-white cursor-pointer" src="@/assets/images/GENIKES_127x40_72dpi.png" loading="lazy" alt="" @click="goHome"></div>
      <div class="header_column w-col w-col-6">
       <slot></slot>
      </div>
      <div class="header_column call_column w-col w-col-3">
        <div class="columns-8 w-row">
          <div class="column-22 w-col w-col-4">
            <a href="javascript:;" v-for="language in languages" :key="language" :class="[`link lan${language}`, $i18n.locale === language ? 'active' : '']" @click="setLanguage(language)">{{language.toUpperCase()}}</a>
            <!-- <a href="#" class="link lanen">EN</a>
            <a href="#" class="link langr">GR</a> -->
          </div>
          <div class="w-col w-col-8">
            <a href="tel:80008787" class="call_link w-inline-block"><img src="@/assets/images/call.svg" loading="lazy" alt="" class="image-8">
              <h1 class="heading-5">8000.87.87</h1>
            </a>
          </div>
        </div>
      </div>
    </div>
  </header>
  </div>
</template>

<script>

import { supportedlanguages, loadLanguageAsync } from '@/i18n';

export default {
  data() {
    return {
      languages: supportedlanguages || ['en']
    };
  },
  methods: {
    goHome() {
      if (this.$route.path !== `/${this.$route.meta.layout.toLowerCase()}`) {
        this.$router.push({ path: `/${this.$route.meta.layout.toLowerCase()}` });
      }
    },
    async setLanguage(lang) {
      loadLanguageAsync(lang);
      await this.$store.dispatch(`${this.$route.meta.layout.toLowerCase()}/${this.$route.meta.layout.toLowerCase()}SetLanguage`);
    }
  },
};
</script>
